import React from 'react';
import PropTypes from 'prop-types';

const FlagIcon = ({ className, size = 'md' }) => {
  const sizes = {
    sm: { width: '10.67', height: '13.33' },
    md: { width: '18', height: '22' },
  };

  return (
    <svg
      width={sizes[size].width}
      height={sizes[size].height}
      viewBox='0 0 18 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        className={className}
        d='M1 14C1 14 2 13 5 13C8 13 10 15 13 15C16 15 17 14 17 14V2C17 2 16 3 13 3C10 3 8 1 5 1C2 1 1 2 1 2V14ZM1 14V21'
        stroke='#242546'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

FlagIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default FlagIcon;
